// page.ts
export interface IPageData {
  Id: string;
  SEO: {
    Title: string;
    Description: string;
    Keywords: string;
    // Route: string;
    Code: string;
  };
  // For simplicity, we use any[] here; in your project this should be WidgetTypes[]
  Items: any[];
  Active: boolean;
}

export interface IPageState {
  values: IPageData;
  errors: {
    SEO: {
      Title: string;
      Description: string;
      Keywords: string;
      Code: string;
      // Route: string;
    };
    Items: any[];
  };
  touched: {
    SEO: {
      Title: boolean;
      Description: boolean;
      Keywords: boolean;
      Code: boolean;
      // Route: boolean;
    };
    Items: any[];
  };
}export const initialIPageState: IPageState = {
  values: {
    Id: '',
    SEO: {
      Title: '',
      Description: '',
      Keywords: '',
      // Route: '',
      Code: ''
    },
    Items: [],
    Active: true
  },
  touched: {
    SEO: {
      Title: false,
      Description: false,
      Keywords: false,
      // Route: false,
      Code: false
    },
    Items: []
  },
  errors: {
    SEO: {
      Title: '',
      Description: '',
      Keywords: '',
      // Route: '',
      Code: ''
    },
    Items: []
  }
};